import axios from 'axios';
import { TENANT } from '../../config/tenant';

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    subpath: TENANT
  }
});

export default axiosClient;
